import { createContext, useContext } from 'react'

interface CostCenterAssignmentsContextValue {
  hasNewStructureEnabled: boolean
}

const CostCenterAssignmentsContext = createContext<CostCenterAssignmentsContextValue>({
  hasNewStructureEnabled: false,
})

export const CostCenterAssignmentsProvider = CostCenterAssignmentsContext.Provider

export const useCostCenterAssignmentsContext = () => useContext(CostCenterAssignmentsContext)
